var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4F700E37-96C9-4EA3-B2C5-2F499C11807F@0.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navic-GoSend---Phase-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.8-Error---Image-not-loaded",
    transform: "translate(-66.000000, -875.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PO",
    transform: "translate(0.000000, 677.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photo",
    transform: "translate(16.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    transform: "translate(50.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    strokeWidth: 0.666666667,
    fill: "#D8D8D8",
    opacity: 0,
    x: 0.333333333,
    y: 0.333333333,
    width: 63.3333333,
    height: 63.3333333
  }), /*#__PURE__*/React.createElement("g", {
    id: "club/spot_hero/spot_hero_error_placeholder",
    transform: "translate(3.333333, 11.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2052047,4.22713333 L29.1998713,0.545133333 L6.91520466,5.97246667 C6.91520466,5.97246667 0.179871322,5.2218 0.406537988,14.0591333 C0.662537988,24.1371333 2.78053799,35.5598 2.78053799,35.5598 C2.78053799,35.5598 2.93053799,41.3764667 11.3172047,41.4244667 C19.854538,41.4718 25.946538,40.5331333 30.5818713,39.7991333 L36.4518713,32.0538 L34.4918713,25.6291333 L29.8338713,22.8524667 L31.918538,20.2898 L30.2258713,14.0244667 C30.0838713,12.8251333 24.5198713,13.1778 24.5698713,12.3358 L29.854538,5.87913333 C30.2312047,5.4178 30.362538,4.8018 30.2052047,4.22713333",
    id: "Fill-4",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5066047,34.9751333 L34.253938,39.5304667 C34.253938,39.5304667 40.2366047,39.8811333 45.899938,39.9398 C50.4566047,39.9871333 54.0946047,39.6931333 55.4112713,37.9531333 C57.3632713,35.3751333 56.705938,28.1471333 56.705938,28.1471333 L39.4512713,3.63713333 L28.6632713,9.44913333 L28.6632713,14.7051333 L35.8092713,17.1524667 L33.087938,19.6891333 L33.2752713,25.9858 L38.2446047,28.5018 L31.5066047,34.9751333 Z",
    id: "Fill-6",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8848713,34.218 C55.0808713,33.4606667 56.6862047,31.6186667 56.7462047,27.1753333 C56.8382047,20.354 56.653538,8.028 56.653538,8.028 C56.653538,8.028 56.787538,1.55466667 47.983538,0.532 C45.6482047,0.260666667 42.4128713,0.096 38.925538,0 L28.9942047,8.578 C28.389538,9.10066667 28.613538,10.0866667 29.3848713,10.2966667 L37.4462047,12.4893333 C38.1948713,12.694 38.4348713,13.6366667 37.8742047,14.174 L33.303538,18.5553333 C32.8402047,18.9993333 32.9102047,19.7593333 33.447538,20.1106667 L40.445538,24.6946667 C40.9828713,25.0466667 41.0528713,25.808 40.587538,26.252 L32.3562047,34.1033333 C32.1108713,34.3373333 31.5068713,34.9753333 31.5068713,34.9753333 C40.193538,35.0393333 49.589538,34.816 51.973538,34.7533333 C52.6482047,34.7353333 53.3148713,34.5793333 53.8848713,34.218",
    id: "Fill-8",
    fill: "#A4A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6524713,27.9771333 C52.6524713,27.9771333 49.7624713,21.4204667 48.6044713,19.0004667 C47.9164713,17.5618 45.2684713,12.5404667 45.2684713,12.5404667 C44.6424713,11.2311333 42.839138,11.0791333 42.001138,12.2638 C42.001138,12.2638 39.357138,15.9224667 38.4944713,17.1458 C37.851138,18.0578 36.311138,20.2871333 35.503138,21.4578 L40.445138,24.6944667 C40.983138,25.0464667 41.053138,25.8078 40.587138,26.2518 L37.1218047,29.5578 L51.561138,29.6905271 C52.4464713,29.6991333 53.0338047,28.7744667 52.6524713,27.9771333",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1478713,35.2147333 L34.2818713,26.3534 C34.6852047,25.8527333 34.516538,25.1074 33.9372047,24.8280667 L26.3998713,21.1994 C25.8212047,20.9207333 25.652538,20.1767333 26.0532047,19.6754 L30.012538,14.7340667 C30.4972047,14.1287333 30.1358713,13.2254 29.3672047,13.1207333 L21.088538,12.0014 C20.296538,11.8940667 19.944538,10.9454 20.476538,10.3480667 L29.1998713,0.544733333 C19.594538,1.54273333 8.11787132,3.3194 8.11787132,3.3194 C8.11787132,3.3194 -0.222128678,3.57206667 0.0045379884,12.4087333 C0.260537988,22.4867333 2.24253799,31.6520667 2.24253799,31.6520667 C2.24253799,31.6520667 2.50653799,37.4374 10.892538,37.4847333 C14.5432047,37.5060667 20.2672047,36.9394 26.510538,36.1627333 C26.510538,36.1627333 26.9358713,35.4787333 27.1478713,35.2147333",
    id: "Fill-12",
    fill: "#A4A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.936938,24.828 L28.6142713,22.2653333 C28.3656047,22.752 28.200938,23.0746667 28.200938,23.0746667 C27.726938,23.9806667 26.6196047,24.348 25.6982713,23.9073333 L19.2122713,20.8013333 C18.4076047,20.418 17.4422713,20.6446667 16.8942713,21.346 L9.61493799,30.6806667 C8.96160466,31.522 9.64693799,32.7346667 10.7036047,32.606 L31.2782713,30.0846667 L34.2822713,26.3533333 C34.684938,25.8526667 34.5162713,25.1073333 33.936938,24.828",
    id: "Fill-14",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.636138,8.74206667 C11.6794713,8.14273333 9.64613799,9.26606667 9.09413799,11.2507333 C8.54147132,13.2347333 9.68013799,15.3307333 11.6368047,15.9294 C13.5934713,16.5294 15.6268047,15.4054 16.1788047,13.4214 C16.732138,11.4367333 15.5934713,9.3414 13.636138,8.74206667",
    id: "Fill-16",
    fill: "#FFFFFF"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenImage);
export default __webpack_public_path__ + "static/media/broken-image.f404751a78cfdbc7e99affae51a3f18f.svg";
export { ForwardRef as ReactComponent };